module.exports = __webpack_public_path__ + "img/seller-a1.2665e4d2.png";